module.exports = __webpack_public_path__ + "img/lotus.be5030ca.webp";